 <template>
    <div class="container">
        <div class="content">
            <img class="tip_icon" src="../assets/images/squareNine_titlepic.png" alt="">
            <div v-if="lotteryDetail.user_have_credit" class="currentCredit">{{'当前积分：'+lotteryDetail.user_have_credit}}</div>
            <div id="squareBox" :style="{backgroundImage: lightflag ? 'url('+sqBg+')' : 'url('+sqBgGif+')'}">
                <div class="container" v-if="prizeDataChange.length">
                    <div class="item cell" :style="{backgroundColor: currentIndex == 0 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[0]">
                            <img :src="this.prizeDataChange[0].image" alt="">
                            <span>{{ this.prizeDataChange[0].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                    <div class="item cell" :style="{backgroundColor: currentIndex == 1 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[1]">
                            <img :src="this.prizeDataChange[1].image" alt="">
                            <span>{{ this.prizeDataChange[1].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                    <div class="item cell" :style="{backgroundColor: currentIndex == 2 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[2]">
                            <img :src="this.prizeDataChange[2].image" alt="">
                            <span>{{ this.prizeDataChange[2].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                    <div class="item cell" :style="{backgroundColor: currentIndex == 7 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[7]">
                            <img :src="this.prizeDataChange[7].image" alt="">
                            <span>{{ this.prizeDataChange[7].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                    <div class="item btn lottery-draw" @click="startLottery">
                        <p v-if="lotteryDetail.credit_desc!=''" style="color:#d66f02;">{{lotteryDetail.credit_desc}}</p>
                    </div>
                    <div class="item cell" :style="{backgroundColor: currentIndex == 3 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[3]">
                            <img :src="this.prizeDataChange[3].image" alt="">
                            <span>{{ this.prizeDataChange[3].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                    <div class="item cell" :style="{backgroundColor: currentIndex == 6 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[6]">
                            <img :src="this.prizeDataChange[6].image" alt="">
                            <span>{{ this.prizeDataChange[6].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                    <div class="item cell" :style="{backgroundColor: currentIndex == 5 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[5]">
                            <img :src="this.prizeDataChange[5].image" alt="">
                            <span>{{ this.prizeDataChange[5].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                    <div class="item cell" :style="{backgroundColor: currentIndex == 4 ? '#ffe481' : ''}">
                        <div class="cellPrize" v-if="this.prizeDataChange[4]">
                            <img :src="this.prizeDataChange[4].image" alt="">
                            <span>{{ this.prizeDataChange[4].name }}</span>
                        </div>
                        <p v-else>谢谢参与</p>
                    </div>
                </div>
            </div>
            <div class="award_btn">
                <p @click="clickAward">我的中奖记录</p>
            </div>
        </div>
        <section class="tip_text_container" v-if="lotteryDetail.show_desc=='1'"><!-- 奖品说明 -->
                <div class="tip_award">
                        <p>奖项说明</p>
                </div>
                <div class="awardList">
                  <ul class="lists">
                    <li class="list" v-for="(item,index) in prizeListData" :key="index">
                      <p class="awardPic" v-if="prizeListImgDisplay">
                          <img :src="item.image" alt="">
                      </p>
                      <p :class="prizeListImgDisplay?'pName':'pName_sec'">{{item.name}}</p>
                      <p :class="prizeListImgDisplay?'pDesc':'pDesc_sec'">{{item.desc}}</p>
                      <p :class="prizeListImgDisplay?'pSur':'pSur_sec'" v-if="lotteryDetail.show_prize_num=='1'">{{'剩余数量：'+item.prize_number}}</p>
                    </li>
                  </ul>
                </div>
        </section>
        <section class="tip_text_container"><!-- 活动说明 -->
                <div class="tip_award">
                        <p>活动说明</p>
                </div>
                <div class="awardList">
                  <div class="lists" v-if="lotteryDetail.about_lottery">
                      <p class="explain">
                        <pre>{{lotteryDetail.about_lottery}}</pre>
                      </p>
                  </div>
                  <div class="lists" v-else>
                      <p class="explain" v-html="lotteryDetail.desc"></p>
                  </div>
                </div>
        </section>
        <section class="foot">
            <div class="logo">
                <img :src="logo_img" alt="">
            </div>
        </section>
        <!-- 实物中奖弹窗 -->
        <formDialog
            :formDialogDisplay.sync="formDialogDisplay"
            :title="prizeReqData.msg"
            :id="prizeReqData.prize_receive_record_id"
            :formList="fillInfo"></formDialog>

        <el-dialog title="" :visible.sync="dialogTip" width="85%" :show-close="false" center>
          <p>{{failMsg}}</p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogTip = false" type="primary">确定</el-button>
          </span>
        </el-dialog>

    </div>
</template>

<script> //type="text/ecmascript-6"
import FormDialog from 'components/formDialog/formDialog'

import sqBg from '../assets/images/lamp.png'
import sqBgGif from '../assets/images/lamp_active.gif'

import {logo_img} from '../config/config';
    export default {
        data() {
          return {
            logo_img,
            formDialogDisplay: false,
            sqBg:sqBg,
            sqBgGif:sqBgGif,
            adjustArr: [1,2,3,5,8,7,6,4],       // currentIndex和实际位置的对应关系
            currentIndex: -1,       // active的位置
            mockIndex: 7,       // 模拟的后台返回的停止位置，直接换算成currentIndex形式
            timeInterval: 200,      // 时间间隔
            times: 0,       // 跳动次数
            timer: null,    // 定时器id
            endFlag: true,      // 减速开关
            flag: true,     // 按钮开关，转动时不允许点击
            lightflag: true,
            prizeReqData:{},    // drawprize接口成功返回的data
            prizeDataChange:[],     // 整列成产品希望的样子
            prizeReqInfo: '',
            fillInfo: {},
            fields: {},
            dialogShow: false,
            formLabelWidth:'25%',
            dialogItemsState: {
                name: false,
                tel: false,
                idcard: false,
                add: false
            },
            dialogTip: false,
            failMsg: '',
            validSubmit:true
          }
        },
        props:['lotteryDetail','prizeListData', 'preview', 'platRight', 'prizeListImgDisplay', 'coordinate'],
        watch: {
          prizeListData(val, oldVal) {
            this.prizeDistribute()
          }
        },
        methods: {
          platRightCheck() {
            if (this.platRight && this.platRight.right === 0) {
              if (this.platRight.apptype === 'WX') {
                this.$router.push('/wxScan')
              } else {
                this.$dialog({
                  message: this.platRight.name,
                  url: this.platRight.url,
                  key: this.platRight.apptype
                })
              }
              return true
            }
          },
            getPrizeIndex(prizeReqData) {
              if (prizeReqData.prize_id) {
                for (let i=0;i<this.prizeDataChange.length;i++) {
                  if (this.prizeDataChange[i].id == prizeReqData.prize_id) {
                    this.init(true, i, prizeReqData)
                    return
                  }
                }
              } else {
                for (let i=0;i<this.prizeDataChange.length;i++) {
                  if (!this.prizeDataChange[i]) {
                    this.init(false, i, prizeReqData)
                    return
                  }
                }
              }
            },
            prizeReq(){
                let vm = this
                let latitude, longitude
                if (this.coordinate) {
                  latitude = this.coordinate.latitude
                  longitude = this.coordinate.longitude
                }
                this.Get({
                    url: '/activity/api.php',
                    data: {
                        m: 'front',
                        subm: 'lottery',
                        action: 'drawprize',
                        preview: vm.preview,
                        lat: latitude || '',
                        lng: longitude || '',
                    },
                    success: function(data){
                        if(data.code == 3001){
                            vm.lightflag = false
                            vm.prizeReqData = data.data
                            vm.getPrizeIndex(vm.prizeReqData)
                            // 我直接用请求中的credit和credittype吧
                            if(data.data.credit_type != 0 && data.data.credit != 0 && typeof(vm.lotteryDetail.user_have_credit)!=='undefined'){
                                if(data.data.credit_type == 1){
                                    vm.lotteryDetail.user_have_credit -= vm.lotteryDetail.credit;
                                }else if(data.data.credit_type == 2){
                                    vm.lotteryDetail.user_have_credit += vm.lotteryDetail.credit;
                                }
                            }
                        }
                    },
                    error: function(data){
                        if (data.code==5007||data.code == 5110||data.code==5011||data.code==5013||data.code==5014||data.code==5020||data.code==5107) {
                            // vm.$router.replace('/');
                            // window.location.reload(true);
                        }
                        vm.flag = true
                        vm.alertPrize(data.msg)
                    }
                })
            },
            prizeDistribute() {
              // 获取奖品数组
              const prizeData = this.prizeListData
              switch(prizeData.length){
                case 1:
                  this.prizeDataChange = [
                      prizeData[0],
                      false,
                      prizeData[0],
                      false,
                      prizeData[0],
                      false,
                      prizeData[0],
                      false
                  ];
                  break;
                case 2:
                  this.prizeDataChange = [
                      prizeData[0],
                      false,
                      prizeData[0],
                      false,
                      prizeData[1],
                      false,
                      prizeData[1],
                      false
                  ];
                  break;
                case 3:
                  this.prizeDataChange = [
                      prizeData[0],
                      false,
                      prizeData[0],
                      prizeData[1],
                      prizeData[2],
                      false,
                      prizeData[2],
                      prizeData[1]
                  ];
                  break;
                case 4:
                  this.prizeDataChange = [
                      prizeData[0],
                      false,
                      prizeData[1],
                      prizeData[2],
                      prizeData[3],
                      false,
                      prizeData[3],
                      prizeData[2]
                  ];
                  break;
                case 5:
                  this.prizeDataChange = [
                      prizeData[0],
                      false,
                      prizeData[1],
                      prizeData[3],
                      prizeData[4],
                      false,
                      prizeData[4],
                      prizeData[2]
                  ];
                  break;
                case 6:
                  this.prizeDataChange = [
                      prizeData[0],
                      false,
                      prizeData[1],
                      prizeData[3],
                      prizeData[5],
                      false,
                      prizeData[4],
                      prizeData[2]
                  ];
                  break;
                case 7:
                  this.prizeDataChange = [
                      prizeData[0],
                      prizeData[1],
                      prizeData[2],
                      prizeData[4],
                      false,
                      prizeData[6],
                      prizeData[5],
                      prizeData[3]
                  ];
                  break;
              }
            },
            startLottery() {
              // 端检查
              if (this.platRightCheck()) return
              if (this.flag) {
                this.flag = false
                this.prizeReq()
              } else {
                this.$message({
                  message: '正在抽奖中！！',
                  center: true
                });
              }
            },
            roll(flag, index, data){
                this.times += 1
                if(this.times >= 70 && this.currentIndex == index){
                    this.rollEnd(flag, index, data)
                    return
                }

                this.timerRoll = setInterval(() => {
                    // currentIndex循环建立
                    if(this.currentIndex >= 7){
                        this.currentIndex = 0
                    }else{
                        this.currentIndex += 1
                    }
                    // 跳动间隔控制，模拟真实效果
                    if(this.timeInterval <= 50){
                        this.timeInterval = 50
                    }else{
                        this.timeInterval -= 50
                    }
                    clearInterval(this.timerRoll)
                    this.roll(flag, index, data)
                }, this.timeInterval)
            },
            rollEnd(flag, index, data) {

                this.timerRollEnd = setInterval(() => {
                    // currentIndex循环建立
                    if(this.currentIndex >= 7){
                        this.currentIndex = 0
                    }else{
                        this.currentIndex += 1
                    }
                    // 跳动间隔控制，实现感官效果
                    if(this.timeInterval >= 1000){
                        this.timeInterval = 1000
                    }else{
                        this.timeInterval += 50
                    }
                    clearInterval(this.timerRollEnd)
                    this.rollEnd(flag, index, data)
                }, this.timeInterval)
                if(!this.endFlag && this.currentIndex == index){
                    clearInterval(this.timerRollEnd)
                    /* 延迟800ms出现弹框提示 */
                    setTimeout(() => {
                      this.feedback(flag, index, data)
                    }, 800);
                    // 这个标记代表flag，同样用于控制灯的背景交替
                    this.flag = true
                    this.lightflag = true
                }
                this.endFlag = false
            },
            feedback(flag, index, data){
                if(flag){
                    if(data.prize_type == 1 && data.receive_msg.length){
                        this.fields = {
                            m: 'front',
                            subm: 'lottery',
                            action: 'receivemsg',
                            id: data.prize_receive_record_id
                        }
                        for(let i=0;i<data.receive_msg.length;i++){
                            let item = data.receive_msg[i]
                            this.fillInfo[item] = ''
                        }
                        // 打开中奖表单弹窗
                        this.formDialogDisplay = true;
                        // this.showField(this.fillInfo)
                    }else if(data.prize_type === 3){
                        this.alertPrize(data.msg, '立即领取', data.prize_url)
                    } else {
                        this.resultTip(data)
                    }
                }else{
                    this.resultTip(data)
                }

            },
            resultTip(data){
                let msgChange = ''
                if(data.invented_prize_info.verification){
                    msgChange = data.msg + '<br>' + data.invented_prize_info.verification
                }else{
                    msgChange = data.msg
                }
                this.alertPrize(msgChange)
            },
            alertPrize(){//中奖后的弹框
              this.$emit.apply(this,[].concat.apply(['alertPrize'], arguments));
            },
            init(flag, i, data) {
                this.currentIndex = 0   // 重置起始的位置
                this.timeInterval = 200     //  重置起始的跳动速度
                this.times = 0  // 重置跳动次数
                this.endFlag = true     // 重置用于减速跳动的开关
                this.roll(flag, i, data)
                // this.flag = false
            },
            clickAward() {
              // 端检查
              if (this.platRightCheck()) return
              this.$emit('clickAward')
            },
            getRandom(min, max) {
                let range = max - min
                return min + Math.round(Math.random() * range)
            }
        },
        components: {
            FormDialog
        }
    }
</script>

<style scoped>
    .content{
        background-image: url('../assets/images/title_bg.png');
        background-size: 100% 100%;
    }
    .tip_icon{
        width: 50%;
        margin: 15px auto;
    }
    .currentCredit{
        margin-bottom: 10px;
        color: #444e45;
    }
    #squareBox{
        width: 96vw;
        height: 96vw;
        margin: 0 auto;
        background: orange;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background: url(/static/image/lamp_active.gif); */
        background-size: 100% 100%;
    }
        #squareBox .container{
            width: 88vw;
            height: 88vw;
            background: #f06d50;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            border-radius: 8px
        }
        #squareBox .container .item{
            width: 32.8%;
            height: 32.8%;
            background: #fff9c1;
            border-radius: 8px;
        }
        .cell p {
            font-size: 20px;
            color: #dc5900;
            margin-top: 40%;
        }
        .cellPrize{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .cellPrize img{
            max-width: 50%;
            max-height: 50%;
            display: block;
            margin-bottom: 4px;
        }
        .cellPrize span{
            width: 90%;
            font-size: 14px;
            line-height: 1;
            color: #dc5900;
        }
        #squareBox .container .active{
            background: #ffe481;
        }
        #squareBox .container .btn{
            background: url('../assets/images/squareNine_btn.png');
            background-size: 100% 100%;
        }
        .btn p{
            margin-top: 60%;
        }
</style>



// WEBPACK FOOTER //
// src/components/squaredNine.vue